import useSWR from "swr";
import axios from "axios";

function useSupportTicket({ ticketId }) {
  return useSWR([`${process.env.REACT_APP_API_URL}/support-tickets/${ticketId}`], async ([url]) => {
    const { data: supportTicket } = await axios.get(url);

    return { supportTicket };
  });
}

export default useSupportTicket;
